import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';

// vertical tabs https://mui.com/material-ui/react-tabs/#vertical-tabs

class TabWizardComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1
    };
  }
  componentDidMount() {
    if (this.props.activeTab) {
      this.setState({ activeTab: this.props.activeTab || 1 })
    }
  }

  titleMapping = tabDataArray => {
    return tabDataArray.map((data, index) => {
      return (
        <NavItem key={index + 1}>
          <NavLink
            className={classnames({
              active: this.state.activeTab === index + 1
            })}
            onClick={() => {
              this.toggleTab(index + 1);
            }}
          >
            {data.title}
          </NavLink>
        </NavItem>
      );
    });
  };

  contentMapping = tabDataArray => {
    return tabDataArray.map((data, index) => {
      return (
        <TabPane key={index + 1} tabId={index + 1}>
          {data.content}
        </TabPane>
      );
    });
  };

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
      if (this.props.onCallback) { this.props.onCallback(tab) }
    }
  };

  togglePaperTab = (event, value) => {
    if (this.state.activeTab !== value + 1) {
      this.setState({
        activeTab: value + 1
      });
      if (this.props.onCallback) { this.props.onCallback(value + 1) }
    }
  };

  papertitleMapping = tabDataArray => {
    return tabDataArray.map((data, index) => {
      return (
        data.badge ?
          <Tab key={index} label={
            <Badge badgeContent={data.badge} color="secondary">
              {data.title}
            </Badge>
          } />
          : <Tab key={index} label={data.title} />
      );
    });
  };

  paperContentMapping = tabDataArray => {
    return tabDataArray.map((data, index) => {
      return (
        <div
          hidden={this.state.activeTab - 1 !== index}
          id={`wrapped-tabpanel-${index}`}
        >{data.content}</div>
      );
    });
  };

  render() {
    let {
      tabDataArray, // array of object filled with title and jsx of the content,
      paper,
      tab10 = false
    } = this.props;
    
    if (!tabDataArray) {
      return <React.Fragment />;
    }

    return (
      paper ?

        <Paper square>
          <Tabs
            value={this.state.activeTab - 1}
            // indicatorColor="#42b549"
            // textColor="#42b549"
            onChange={this.togglePaperTab}
            TabIndicatorProps={{style: {background:'#42b549', color: '#42b549'}}}
          >
            {this.papertitleMapping(tabDataArray)}
          </Tabs>
          <TabContent
            activeTab={this.state.activeTab - 1}
            className="custom-tab-content"
          >
            {this.paperContentMapping(tabDataArray)}
          </TabContent>
        </Paper>

        :

        <div className={tab10 ? "custom-tab-style-10" : "custom-tab-style"}>
          <Nav tabs className="custom-tab-nav border-bottom-0" styles={{
            padding: 0
          }}>
            {this.titleMapping(tabDataArray)}
          </Nav>
          <TabContent
            activeTab={this.state.activeTab}
            className="custom-tab-content"
          >
            {this.contentMapping(tabDataArray)}
          </TabContent>
        </div>

    );
  }
}

export default TabWizardComponent;
